// Module
var code = "<toolbar-font-family-menu fonts=\"parent.elementFontFamily\" menu-type=\"textFont\" on-select=\"parent.updateFontFamily(font)\" chosen-font=\"parent.textboxFontFamily\"> </toolbar-font-family-menu> ";
// Exports
module.exports = code;